import React from 'react';
import {HStack, VStack} from '@chakra-ui/react';
import {TextG12} from '../../../components/typography';
import {ConnectionStatus} from '../../../hooks/usePublicProfile';
import styled from 'styled-components';

const ConnectBtn = styled.button<{$status: ConnectionStatus}>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  border-radius: 28px;
  border: none;
  font-family: Gordita;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.$status === 'connected' ? '#1A1A1A' : 'white')};
  background: ${(props) =>
    props.$status === 'connected'
      ? '#F4F4F4'
      : props.$status === 'pending'
        ? '#B0B0B0'
        : '#E02F84'};
  box-shadow: ${(props) =>
    props.$status === 'none' ? '0 -4px 0 0 rgba(0, 0, 0, 0.25) inset' : 'none'};
  cursor: pointer;
  transition: all 0.15s ease;
  &:active {
    transform: scale(0.98);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const MessageBtn = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  border-radius: 28px;
  border: 2px solid #e5e5e5;
  font-family: Gordita;
  font-size: 14px;
  font-weight: 500;
  color: #262626;
  background: #e9e9e9;
  cursor: pointer;
  transition: all 0.15s ease;
  &:active {
    transform: scale(0.98);
    background: #fafafa;
  }
`;

interface ConnectMessageButtonsProps {
  connectionStatus: ConnectionStatus;
  onConnect: () => void;
  onCancelRequest: () => void;
  onUnfriend: () => void;
  onMessage: () => void;
  isConnecting?: boolean;
}

const ConnectMessageButtons = ({
  connectionStatus,
  onConnect,
  onCancelRequest,
  onUnfriend,
  onMessage,
  isConnecting,
}: ConnectMessageButtonsProps) => {
  const connectLabel =
    connectionStatus === 'connected'
      ? 'Connected'
      : connectionStatus === 'pending'
        ? 'Request Sent'
        : 'Connect';

  const connectIcon =
    connectionStatus === 'connected'
      ? 'fi fi-rr-check'
      : connectionStatus === 'pending'
        ? 'fi fi-rr-clock'
        : 'fi fi-rr-user-add';

  const handleConnectClick = () => {
    if (isConnecting) return;
    if (connectionStatus === 'none') onConnect();
    else if (connectionStatus === 'pending') onCancelRequest();
    else if (connectionStatus === 'connected') onUnfriend();
  };

  return (
    <VStack spacing={1} align="stretch" px={4} py={3}>
      <HStack spacing={3}>
        <ConnectBtn
          $status={connectionStatus}
          onClick={handleConnectClick}
          disabled={isConnecting}>
          <i className={connectIcon} style={{fontSize: '14px'}} />
          {isConnecting ? 'Sending...' : connectLabel}
        </ConnectBtn>
        <MessageBtn onClick={onMessage}>
          <i className="fi fi-rr-paper-plane" aria-hidden="true" style={{fontSize: '14px'}} />
          Message
        </MessageBtn>
      </HStack>
      <TextG12 mt="6px" color="#757D84" textAlign="center">
        <i className="fi fi-rr-info" aria-hidden="true" style={{fontSize: '10px', marginRight: '4px'}} />
        Messaging happens through your shared event chats.
      </TextG12>
    </VStack>
  );
};

export default ConnectMessageButtons;
